export const HALF_PAGE_ABOVE_QUARTER_MESSAGE =
  'Une demi-page ne peut pas être placée au-dessus d’un quart de page sur la même page.';

const FORMAT_GRID = {
  '1/4 PAGE': { colSpan: 1, rowSpan: 1 },
  '1/2 PAGE': { colSpan: 2, rowSpan: 1 },
  PAGE: { colSpan: 2, rowSpan: 2 },
};

function inferPubFormat(slot) {
  if (slot?.vente?.format) {
    return slot.vente.format;
  }
  const colSpan = slot?.colSpan ?? 0;
  const rowSpan = slot?.rowSpan ?? 0;
  if (colSpan === 1 && rowSpan === 1) return '1/4 PAGE';
  if (colSpan === 2 && rowSpan === 1) return '1/2 PAGE';
  if (colSpan === 2 && rowSpan === 2) return 'PAGE';
  return null;
}

function hasHalfPageAboveQuarter(slots) {
  const pubs = (slots ?? []).filter((slot) => inferPubFormat(slot));

  for (const halfSlot of pubs) {
    if (inferPubFormat(halfSlot) !== '1/2 PAGE') continue;

    const halfRow = halfSlot.row ?? 1;
    for (const quarterSlot of pubs) {
      if (quarterSlot === halfSlot) continue;
      if (inferPubFormat(quarterSlot) !== '1/4 PAGE') continue;

      const quarterRow = quarterSlot.row ?? 1;
      if (halfRow < quarterRow) {
        return true;
      }
    }
  }

  return false;
}

export function findCdfPageByKey(spreads, pageKey) {
  for (const spread of spreads ?? []) {
    if (spread.left?.key === pageKey) return spread.left;
    if (spread.right?.key === pageKey) return spread.right;
    if (spread.page?.key === pageKey) return spread.page;
  }
  return null;
}

function resolveLibreSlot(slots, slotId) {
  const direct = (slots ?? []).find((slot) => slot.id === slotId && slot.type === 'libre');
  if (direct) return direct;

  const cellMatch = String(slotId ?? '').match(/_l(\d+)_(\d+)_/);
  if (!cellMatch) return null;

  const col = Number(cellMatch[1]);
  const row = Number(cellMatch[2]);
  return (slots ?? []).find((slot) => (
    slot.type === 'libre'
    && slot.col === col
    && slot.row === row
  )) ?? null;
}

/**
 * Valide le résultat final après placement (1/2 au-dessus d'un 1/4, ou 1/4 sous un 1/2 déjà en haut).
 *
 * @returns {string|null} Message d'erreur si le placement est interdit.
 */
export function validatePubPlacement(slots, format, targetSlotId, excludeVenteId = null) {
  const size = FORMAT_GRID[format];
  if (!size) {
    return null;
  }

  const libreSlot = resolveLibreSlot(slots, targetSlotId);
  if (!libreSlot) {
    return null;
  }

  const existingPubs = (slots ?? []).filter((slot) => (
    slot.type === 'pub'
    && slot.vente_id
    && slot.vente_id !== excludeVenteId
  ));

  const hypothetical = [
    ...existingPubs,
    {
      type: 'pub',
      row: libreSlot.row ?? 1,
      colSpan: size.colSpan,
      rowSpan: size.rowSpan,
      vente: { format },
    },
  ];

  return hasHalfPageAboveQuarter(hypothetical)
    ? HALF_PAGE_ABOVE_QUARTER_MESSAGE
    : null;
}

/** @deprecated Utiliser validatePubPlacement */
export function validateHalfPagePlacement(slots, format, targetSlotId, excludeVenteId = null) {
  return validatePubPlacement(slots, format, targetSlotId, excludeVenteId);
}
